<template>
  <b-card no-body class="rounded-xl h-full">
    <div class="row">
      <div class="col-sm-12">
        <b-card no-body class="card-h-bgf4f5f6">
          <b-tabs card class="tab-pd-b" active-nav-item-class="font-semibold">
            <b-tab title="Sender IDs / Headers" active>
              <b-card-text><DLTTable /> </b-card-text>
            </b-tab>

            <b-tab title="Short Code">
              <b-card-text><ShortcodeTable /> </b-card-text>
            </b-tab>

            <b-tab title="URL Shortner">
              <b-card-text><URLShortnerTable /> </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </b-card>
</template>

<script>
import DLTTable from "./DLT/DLTTable.vue";
import ShortcodeTable from "./shortcode/ShortcodeTable";
import URLShortnerTable from "./urlshortner/URLShortnerTable.vue";
export default {
  components: {
    DLTTable,
    ShortcodeTable,
    URLShortnerTable,
  },
  data() {
    return {};
  },
};
</script>
<style>
.tab-pd-b .nav-link {
  padding: 10px 15px !important;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  background-color: #fff !important;
}
.card-h-bgf4f5f6 > div > .card-header {
  background: #f4f5f6 !important;
}
</style>
